module.exports = __webpack_public_path__ + "img/flying-features.7dcf543a.png";